import Rectangle from "./Rectangle";
import Length from "./Length";
import AbstractShape from "./AbstractShape";
import Area from "./Area";

export default class Barrel extends AbstractShape {
	static NAME = "barrel";

	constructor( width, height, side_height ) {
		super();

		this.width = width;
		this.height = height;
		this.side_height = side_height;
	}

	get_name() {
		return Barrel.NAME;
	}

	get_enclosing_rectangle() {
		return new Rectangle( this.get_width(), this.get_height() );
	}

	get_area() {
		const height = this.get_height().in_mm();
		const width = this.get_width().in_mm();
		const sideHeight = this.get_side_height().in_mm();

		const circleSegmentHeight = ( height - sideHeight ) / 2;

		const arcRadius = ( circleSegmentHeight / 2 ) + ( Math.pow( width, 2 ) / ( 8 * circleSegmentHeight ) );
		const arcAngle = 2 * Math.asin( width / ( 2 * arcRadius ) );
		const circleSegmentArea = ( Math.pow( arcRadius, 2 ) / 2 ) * ( arcAngle - Math.sin( arcAngle ) );

		const barrelArea = ( width * height ) + ( 2 * circleSegmentArea );

		return new Area( barrelArea );
	}

	get_circumference() {
		const width = this.get_width().in_mm();
		const height = this.get_height().in_mm();
		const sideHeight = this.get_side_height().in_mm();

		const circleSegmentHeight = ( height - sideHeight ) / 2;

		const arcRadius = ( circleSegmentHeight / 2 ) + ( Math.pow( width, 2 ) / ( 8 * circleSegmentHeight ) );
		const arcAngle = 2 * Math.asin( width / ( 2 * arcRadius ) );
		const arcLength = arcRadius * arcAngle;

		const barrelCircumference = ( sideHeight * 2 ) + ( 2 * arcLength );

		return new Length( barrelCircumference );
	}

	get_width() {
		return this.width;
	}

	get_height() {
		return this.height;
	}

	get_side_height() {
		return this.side_height;
	}

	get_maximum_dimensions( maximum_rectangle ) {
		const longest_side = maximum_rectangle.get_longest_side();

		return {
			width: longest_side,
			height: longest_side,
			side_height: maximum_rectangle.get_shortest_side(),
		};
	}

	get_dimension_keys() {
		return [ "width", "height", "side_height" ];
	}

	get_modifier_keys() {
		return [];
	}

	serialize_primitives() {
		return {
			width: this.width.in_mm(),
			height: this.height,
			side_height: this.side_height.in_mm()
		};
	}

	static deserialize_primitives( primitives ) {
		return new Barrel(
			new Length( primitives.width ),
			new Length( primitives.height ),
			new Length( primitives.side_height )
		);
	}

}
